export enum TrackingAction {
  BuildToOrderDetails = 'build_to_order_details',
  Co2Limit = 'co2_limit',
  ConfiguratorError = 'configurator_error',
  ConfiguratorFeedback = 'configurator_feedback',
  ConfiguratorSearch = 'configurator_search',
  ContactDealer = 'contact_dealer',
  ContentTop = 'content_top',
  DeliveryDate = 'delivery_date',
  EngineFilter = 'engine_filter',
  EngineStage = 'engine_stage',
  EngineTiles = 'engine_tiles',
  ExitIntent = 'exit_intent',
  FeasibilityConflict = 'feasibility_conflict',
  Fin = 'fin',
  InfoTiles = 'info_tiles',
  ItemTile = 'item_tile',
  Navigation = 'navigation',
  NextSteps = 'next_step_module',
  NotificationPrimaryOption = 'primary',
  NotificationSecondaryOption = 'secondary',
  OnlineCode = 'onlinecode',
  OnlineCodeLayer = 'onlinecode_layer',
  PermanentSummary = 'permanent_summary',
  SaveConfigurationLayer = 'save_configuration_layer',
  SaveConfigurationNbaBar = 'save_configuration_nba_bar',
  Sfx = 'owcc.audio_module.audio',
  Stage = 'stage',
  SummarySidbar = 'summary_sidebar',
  TransferMotorizationModal = 'transfer_configuration_layer',
  Recommendations = 'recommendations',
  AvailabilityStatus = 'availability_status',
  PreConfigurationPage = 'pre_configuration_page'
}
